import { FreeTilesLayout } from 'common/contracts';

export type FreeTilesCount = 1 | 2 | 3;

const FREE_TILES_COUNT_FALLBACK: FreeTilesCount = 2;

const LAYOUT_BY_COUNT: Record<FreeTilesCount, FreeTilesLayout> = {
  1: '1-in-a-row',
  2: '2-in-a-row',
  3: '3-in-a-row'
};

const COUNT_BY_LAYOUT: Record<FreeTilesLayout, FreeTilesCount> = {
  '1-in-a-row': 1,
  '2-in-a-row': 2,
  '3-in-a-row': 3
};

export const formatFreeTilesLayout = (count: FreeTilesCount): FreeTilesLayout =>
  LAYOUT_BY_COUNT[count];

export const parseFreeTilesLayout = (
  layout: FreeTilesLayout | undefined
): FreeTilesCount => {
  if (layout === undefined) return FREE_TILES_COUNT_FALLBACK;
  return COUNT_BY_LAYOUT[layout];
};

export const parseOptionalFreeTilesLayout = (
  layout: FreeTilesLayout | undefined
): FreeTilesCount | undefined => {
  if (layout === undefined) return undefined;
  return parseFreeTilesLayout(layout);
};

export const clampFreeTilesLayout = (
  value: number | undefined
): FreeTilesCount => {
  if (value === 1 || value === 2 || value === 3) return value;
  return FREE_TILES_COUNT_FALLBACK;
};
